import * as React from "react";
import { useAuth } from "./auth";
import Spinner from "./components/spinner";

interface IProps {
  children: React.ReactChild | React.ReactChild[];
}

function Initialize({ children }: IProps) {
  const { loading } = useAuth();

  if (loading) {
    return <Spinner />;
  }

  return <>{children}</>;
}

export default Initialize;
